"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon_1 = tslib_1.__importDefault(require("../Icon"));

var styles = tslib_1.__importStar(require("./Step.style"));

function Step(_ref) {
  var going = _ref.going,
      done = _ref.done,
      index = _ref.index,
      children = _ref.children;
  return jsx_runtime_1.jsxs("div", Object.assign({
    css: [styles.container, (going || done) && styles.active],
    className: going || done ? 'mrt-progress-active' : 'mrt-progress-inactive'
  }, {
    children: [jsx_runtime_1.jsx("div", Object.assign({
      css: [styles.indexCircle, !going && !done && styles.inActiveIndexCircle]
    }, {
      children: done ? jsx_runtime_1.jsx(Icon_1.default, {
        name: "ic_check_12x12_blue_500",
        alt: "check"
      }, void 0) : index
    }), void 0), jsx_runtime_1.jsx("span", Object.assign({
      css: [styles.stepName, (going || done) && styles.active]
    }, {
      children: children
    }), void 0)]
  }), void 0);
}

exports.default = Step;